var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48095972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EEFFF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#EEFFF6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6693 28L23.5026 26.7917L26.4609 23.8333H16.3359V22.1667H26.4609L23.5026 19.2083L24.6693 18L29.6693 23L24.6693 28Z",
    fill: "#007367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48095972);
export default __webpack_public_path__ + "static/media/frame-48095972.3d04388c617bb5cfd74ef46a7f344107.svg";
export { ForwardRef as ReactComponent };